// src/contexts/AuthContext.jsx
import React, { createContext, useState, useContext, useEffect } from 'react';
import { api } from '../api/mockData';

// 创建 AuthContext
const AuthContext = createContext();

// AuthProvider 组件
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // 初始化时检查登录状态
  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const response = await api.checkAuth();
      if (response.success) {
        setUser(response.data);
        setIsAuthenticated(true);
      } else {
        setUser(null);
        setIsAuthenticated(false);
      }
    } catch (error) {
      console.error('检查认证状态失败:', error);
      setUser(null);
      setIsAuthenticated(false);
    } finally {
      setLoading(false);
    }
  };

  const login = async (credentials) => {
    try {
      setLoading(true);
      const response = await api.login(credentials);
      if (response.success) {
        setUser(response.data);
        setIsAuthenticated(true);
        return { success: true, data: response.data };
      } else {
        setUser(null);
        setIsAuthenticated(false);
        return { success: false, message: response.message };
      }
    } catch (error) {
      console.error('登录失败:', error);
      setUser(null);
      setIsAuthenticated(false);
      return { success: false, message: '登录失败，请稍后重试' };
    } finally {
      setLoading(false);
    }
  };

  const register = async (userData) => {
    try {
      setLoading(true);
      const response = await api.register(userData);
      if (response.success) {
        setUser(response.data);
        setIsAuthenticated(true);
        return { success: true, data: response.data };
      } else {
        setUser(null);
        setIsAuthenticated(false);
        return { success: false, message: response.message };
      }
    } catch (error) {
      console.error('注册失败:', error);
      setUser(null);
      setIsAuthenticated(false);
      return { success: false, message: '注册失败，请稍后重试' };
    } finally {
      setLoading(false);
    }
  };

  const logout = async () => {
    try {
      const response = await api.logout();
      if (response.success) {
        setUser(null);
        setIsAuthenticated(false);
        return { success: true };
      }
    } catch (error) {
      console.error('退出登录失败:', error);
    }
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        isAuthenticated,
        login,
        register,
        logout,
        checkAuth
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

// 自定义 useAuth hook
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth必须在AuthProvider内使用');
  }
  return context;
};